/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { liveblocksControllerAuth } from "./liveblocksControllerAuth";
import { liveblocksControllerResolveMentionSuggestions } from "./liveblocksControllerResolveMentionSuggestions";
import { liveblocksControllerResolveUsers } from "./liveblocksControllerResolveUsers";
import { liveblocksControllerWebhook } from "./liveblocksControllerWebhook";

export function liveblocksService() {
  return { liveblocksControllerAuth, liveblocksControllerResolveUsers, liveblocksControllerResolveMentionSuggestions, liveblocksControllerWebhook }
}